import { createSuperUser, updateUser } from 'api/users';

import type { FormType } from '..';

export const superUserForm: FormType = {
  createFn: createSuperUser,
  updateFn: updateUser,
  cancelText: 'Cancelar',
  submitText: 'Salvar Usuário',
  disableText: 'Desativar Usuário',
  enableText: 'Reativar Usuário',
  successText: 'Usuário salvo com sucesso!',
  fields: [
    [{
      name: 'name',
      type: 'text',
      required: true,
      props: {
        placeholder: 'Nome do usuário',
        label: 'Nome',
      },
    }],
    [{
      name: 'email',
      type: 'text',
      required: true,
      props: {
        placeholder: 'exemplo@email.com',
        label: 'Email',
      },
    }, {
      name: 'phone',
      type: 'text',
      required: true,
      mask: 'maskPhone',
      props: {
        placeholder: '(00) 9 9876-5432',
        label: 'Telefone',
      },
    }], [{
      name: 'documentNumber',
      type: 'text',
      required: true,
      mask: 'maskCpf',
      props: {
        placeholder: '000.000.000-00',
        label: 'CPF',
      },
    }],
  ],
};
